import { render, staticRenderFns } from "./settings_loose_ends.vue?vue&type=template&id=0afe5cb6&scoped=true&"
import script from "./settings_loose_ends.vue?vue&type=script&lang=js&"
export * from "./settings_loose_ends.vue?vue&type=script&lang=js&"
import style0 from "./settings_loose_ends.vue?vue&type=style&index=0&id=0afe5cb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afe5cb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VApp,VCol,VContainer,VForm,VRow,VSubheader,VSwitch,VTextField})
